import { FC, memo, PropsWithChildren } from "react";
import "./panel-sub-title.scss";

const PanelSubTitleComponent: FC<PropsWithChildren> = ({ children }) => {
  return <div className="panel-sub-title">{children}</div>;
};

export const PanelSubTitle = memo(PanelSubTitleComponent);
